module.exports = __webpack_public_path__ + "img/cont-02-tutela.f4447819.svg";